import mongoose from 'mongoose';
import schema, { IServiceReviewDocument } from '../schemas/service-review';

const ServiceReview = (mongoose.models.ServiceReview ||
  mongoose.model<IServiceReviewDocument>('ServiceReview', schema)) as mongoose.Model<
  IServiceReviewDocument
>;

export default ServiceReview;
